// // // // // // import React, { useEffect, useState } from 'react';
// // // // // // import { useNavigate } from 'react-router-dom';
// // // // // // import LogoutButton from '../LogoutButton';
// // // // // // import useAuth from '../useAuth';

// // // // // // const Dashboard = () => {
// // // // // //     const navigate = useNavigate();
// // // // // //     const { logout } = useAuth();
// // // // // //     const [userData, setUserData] = useState(null);
// // // // // //     const accessToken = localStorage.getItem('accessToken');

// // // // // //     useEffect(() => {
// // // // // //         const token = localStorage.getItem('accessToken');
// // // // // //         if (!token) {
// // // // // //             navigate('/');
// // // // // //         }

// // // // // //         // ✅ Get user data from localStorage
// // // // // //         const storedUser = localStorage.getItem('user');
// // // // // //         if (storedUser) {
// // // // // //             setUserData(JSON.parse(storedUser));
// // // // // //         }

// // // // // //         // 🧹 Clean up on component unmount
// // // // // //         return () => {
// // // // // //             localStorage.removeItem('accessToken');
// // // // // //             localStorage.removeItem('refreshToken');
// // // // // //         };
// // // // // //     }, [navigate]);

// // // // // //     useEffect(() => {
// // // // // //         let timeout;
// // // // // //         const events = ['mousemove', 'keydown', 'scroll', 'click'];
// // // // // //         const resetTimer = () => {
// // // // // //             clearTimeout(timeout);
// // // // // //             timeout = setTimeout(() => {
// // // // // //                 logout();
// // // // // //             }, 60 * 60 * 1000); // 1 hour
// // // // // //         };
// // // // // //         events.forEach(event => window.addEventListener(event, resetTimer));
// // // // // //         resetTimer();
// // // // // //         return () => events.forEach(event => window.removeEventListener(event, resetTimer));
// // // // // //     }, [logout]);

// // // // // //     return (
// // // // // //         <div style={{ padding: '2rem' }}>
// // // // // //             <h1>Welcome to the Dashboard</h1>

// // // // // //             <p><strong>Access Token:</strong></p>
// // // // // //             <code>{accessToken}</code>

// // // // // //             {userData && (
// // // // // //                 <div style={{ marginTop: '1rem' }}>
// // // // // //                     <h3>User Details</h3>
// // // // // //                     <p><strong>User ID:</strong> {userData.userId}</p>
// // // // // //                     <p><strong>Email:</strong> {userData.mailid}</p>
// // // // // //                     <p><strong>User Role:</strong> {userData.UserRole}</p>
// // // // // //                     <p><strong>Last Name:</strong> {userData.lastName}</p>
// // // // // //                     <p><strong>First Name:</strong> {userData.firstName}</p>

// // // // // //                 </div>
// // // // // //             )}
// // // // // //             <LogoutButton />
// // // // // //         </div>
// // // // // //     );
// // // // // // };

// // // // // // export default Dashboard;


// // // // // import { useEffect, useState } from 'react';
// // // // // import { useNavigate } from 'react-router-dom';
// // // // // import useAuth from '../useAuth';
// // // // // import MainDashBoard from '../../Components/Dashboard.js/MainDashBoard';
// // // // // import { useLocation } from 'react-router-dom';

// // // // // const Dashboard = () => {
// // // // //     const navigate = useNavigate();
// // // // //     const { logout } = useAuth();
// // // // //     const [userData, setUserData] = useState(null);
// // // // //     const accessToken = localStorage.getItem('accessToken');
// // // // //     const location = useLocation();

// // // // //     useEffect(() => {
// // // // //         const token = localStorage.getItem('accessToken');
// // // // //         if (!token) {
// // // // //             navigate('/');
// // // // //         }

// // // // //         const storedUser = localStorage.getItem('user');
// // // // //         if (storedUser) {
// // // // //             setUserData(JSON.parse(storedUser));
// // // // //         }
// // // // //     }, [navigate]);

// // // // //     useEffect(() => {
// // // // //         if (!location.pathname.startsWith('/dashboard')) {
// // // // //             localStorage.removeItem('accessToken');
// // // // //             localStorage.removeItem('refreshToken');
// // // // //             localStorage.removeItem('user');
// // // // //             localStorage.removeItem('callScript');
// // // // //         }
// // // // //     }, [location.pathname]);

// // // // //     useEffect(() => {
// // // // //         let timeout;
// // // // //         const events = ['mousemove', 'keydown', 'scroll', 'click'];
// // // // //         const resetTimer = () => {
// // // // //             clearTimeout(timeout);
// // // // //             timeout = setTimeout(() => {
// // // // //                 logout();
// // // // //             }, 60 * 60 * 1000); 
// // // // //         };
// // // // //         events.forEach(event => window.addEventListener(event, resetTimer));
// // // // //         resetTimer();
// // // // //         return () => events.forEach(event => window.removeEventListener(event, resetTimer));
// // // // //     }, [logout]);

// // // // //     if (!userData) {
// // // // //         return <div>Loading...</div>; 
// // // // //     }

// // // // //     return (
// // // // //         <div>
// // // // //             <MainDashBoard
// // // // //                     userDetails={userData}
// // // // //                     accessToken={accessToken}
// // // // //                 />
// // // // //         </div>
// // // // //     );
// // // // // };

// // // // // export default Dashboard;


// // // // // // before the console of logout
// // // // import { useEffect, useState } from 'react';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import useAuth from '../useAuth';
// // // // import MainDashBoard from '../../Components/Dashboard.js/MainDashBoard';
// // // // import { useLocation } from 'react-router-dom';

// // // // const Dashboard = () => {
// // // //     const navigate = useNavigate();
// // // //     const { logout } = useAuth();
// // // //     const [userData, setUserData] = useState(null);
// // // //     const accessToken = localStorage.getItem('accessToken');
// // // //     const location = useLocation();

// // // //     useEffect(() => {
// // // //         const token = localStorage.getItem('accessToken');
// // // //         if (!token) {
// // // //             navigate('/');
// // // //         }

// // // //         const storedUser = localStorage.getItem('user');
// // // //         if (storedUser) {
// // // //             setUserData(JSON.parse(storedUser));
// // // //         }
// // // //     }, [navigate]);

// // // //     useEffect(() => {
// // // //         if (!location.pathname.startsWith('/dashboard')) {
// // // //             localStorage.removeItem('accessToken');
// // // //             localStorage.removeItem('refreshToken');
// // // //             localStorage.removeItem('user');
// // // //             localStorage.removeItem('callScript');
// // // //         }
// // // //     }, [location.pathname]);

// // // // useEffect(() => {
// // // //     let timeout;
// // // //     let interval;
// // // //     const events = ['mousemove', 'keydown', 'scroll', 'click'];
// // // //     const timeoutDuration = 60 * 60 * 1000;
// // // //     let lastActivityTime = Date.now();

// // // //     const resetTimer = () => {
// // // //         const now = Date.now();
// // // //         if (now - lastActivityTime < 1000) return;
// // // //         lastActivityTime = now;

// // // //         clearTimeout(timeout);
// // // //         clearInterval(interval);
// // // //         console.log('Inactivity timer reset due to user activity.');
// // // //         const startTime = Date.now();
// // // //         timeout = setTimeout(() => {
// // // //             console.log(`User logged out due to inactivity after ${timeoutDuration / (60 * 1000)} minutes of no usage.`);
// // // //             logout();
// // // //         }, timeoutDuration);

// // // //         interval = setInterval(() => {
// // // //             const elapsed = Date.now() - startTime;
// // // //             const remaining = timeoutDuration - elapsed;
// // // //             if (remaining > 0) {
// // // //                 console.log(`Time remaining before logout: ${Math.ceil(remaining / (60 * 1000))} minutes`);
// // // //             }
// // // //         }, 60 * 1000); 
// // // //     };

// // // //     console.log('Inactivity timer started.');
// // // //     resetTimer(); 
// // // //     events.forEach(event => window.addEventListener(event, resetTimer));
// // // //     return () => {
// // // //         clearTimeout(timeout);
// // // //         clearInterval(interval);
// // // //         events.forEach(event => window.removeEventListener(event, resetTimer));
// // // //     };
// // // // }, [logout]);

// // // //     if (!userData) {
// // // //         return <div>Loading...</div>;
// // // //     }

// // // //     return (
// // // //         <div>
// // // //             <MainDashBoard
// // // //                 userDetails={userData}
// // // //                 accessToken={accessToken}
// // // //             />
// // // //         </div>
// // // //     );
// // // // };

// // // // export default Dashboard;

// // // // before overlay

// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import useAuth from '../useAuth';
// import MainDashBoard from '../../Components/Dashboard.js/MainDashBoard';
// import { useLocation } from 'react-router-dom';

// const Dashboard = () => {
//     const navigate = useNavigate();
//     const { logout } = useAuth();
//     const [userData, setUserData] = useState(null);
//     const accessToken = localStorage.getItem('accessToken');
//     const location = useLocation();
//     const [showWarning, setShowWarning] = useState(false);
//     const [timeLeft, setTimeLeft] = useState(0);

//     useEffect(() => {
//         const token = localStorage.getItem('accessToken');
//         if (!token) {
//             navigate('/');
//         }

//         const storedUser = localStorage.getItem('user');
//         if (storedUser) {
//             setUserData(JSON.parse(storedUser));
//         }
//     }, [navigate]);

//     useEffect(() => {
//         if (!location.pathname.startsWith('/dashboard')) {
//             localStorage.removeItem('accessToken');
//             localStorage.removeItem('refreshToken');
//             localStorage.removeItem('user');
//             localStorage.removeItem('callScript');
//         }
//     }, [location.pathname]);

//     useEffect(() => {
//         let timeout;
//         let warningTimeout;
//         let interval;
//         const events = ['mousemove', 'keydown', 'scroll', 'click'];
//         const inactivityLimit = 60 * 1000; // 1 minute
//         const warningDuration = 60 * 60 * 1000; // 60 minutes warning period
//         let lastActivityTime = Date.now();

//         const resetTimer = () => {
//             const now = Date.now();
//             if (now - lastActivityTime < 1000) return;
//             lastActivityTime = now;

//             clearTimeout(timeout);
//             clearTimeout(warningTimeout);
//             clearInterval(interval);
//             setShowWarning(false);
//             console.log('Inactivity timer reset due to user activity.');

//             timeout = setTimeout(() => {
//                 setShowWarning(true);
//                 setTimeLeft(3600); // Start with 3600 seconds (60 minutes)
//                 console.log('Warning started, initial timeLeft:', 3600);
//                 const startWarning = Date.now();
//                 warningTimeout = setTimeout(() => {
//                     console.log('User logged out due to inactivity.');
//                     logout();
//                 }, warningDuration);

//                 interval = setInterval(() => {
//                     const elapsed = Date.now() - startWarning;
//                     const remainingSeconds = Math.max(0, 3600 - Math.floor(elapsed / 1000)); // Countdown from 3600
//                     console.log('Interval tick, remainingSeconds:', remainingSeconds);
//                     setTimeLeft(remainingSeconds);
//                     if (remainingSeconds <= 0) {
//                         clearInterval(interval);
//                         console.log('Countdown finished');
//                     }
//                 }, 1000);
//             }, inactivityLimit);
//         };

//         console.log('Inactivity timer started.');
//         resetTimer();
//         events.forEach(event => window.addEventListener(event, resetTimer));

//         return () => {
//             clearTimeout(timeout);
//             clearTimeout(warningTimeout);
//             clearInterval(interval);
//             console.log('Cleanup executed');
//         };
//     }, [logout]);

//     const handleKeepLoggedIn = () => {
//         setShowWarning(false);
//         setTimeLeft(0);
//     };

//     if (!userData) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div>
//             {showWarning && (
//                 <div style={{
//                     position: 'fixed',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     background: 'white',
//                     padding: '20px',
//                     borderRadius: '5px',
//                     boxShadow: '0 0 10px rgba(0,0,0,0.5)',
//                     textAlign: 'center',
//                     zIndex: 1000,
//                 }}>
//                     <div style={{ fontSize: '18px', marginBottom: '10px' }}>
//                         Your session is about to expire
//                     </div>
//                     <div style={{ fontSize: '24px', color: 'red', marginBottom: '20px' }}>
//                         {String(Math.floor(timeLeft / 3600)).padStart(2, '0')}:
//                         {String(Math.floor((timeLeft % 3600) / 60)).padStart(2, '0')}:
//                         {String(timeLeft % 60).padStart(2, '0')}
//                     </div>
//                     <button
//                         onClick={handleKeepLoggedIn}
//                         style={{
//                             backgroundColor: 'red',
//                             color: 'white',
//                             padding: '10px 20px',
//                             border: 'none',
//                             borderRadius: '5px',
//                             cursor: 'pointer',
//                         }}
//                     >
//                         KEEP ME LOGGED IN
//                     </button>
//                 </div>
//             )}
//             <MainDashBoard
//                 userDetails={userData}
//                 accessToken={accessToken}
//             />
//         </div>
//     );
// };

// export default Dashboard;

// // the over will start after 1 min of inactivity and will logout after 60 mins of warning

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../useAuth';
import MainDashBoard from '../../Components/Dashboard.js/MainDashBoard';
import { useLocation } from 'react-router-dom';

const Dashboard = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const [userData, setUserData] = useState(null);
    const accessToken = localStorage.getItem('accessToken');
    const location = useLocation();
    const [showWarning, setShowWarning] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            navigate('/');
        }

        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUserData(JSON.parse(storedUser));
        }
    }, [navigate]);

    useEffect(() => {
        if (!location.pathname.startsWith('/dashboard')) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            localStorage.removeItem('telnyxToken');
            localStorage.removeItem('Userpreference');
            localStorage.removeItem('UIComponents');
            localStorage.removeItem('callScript');
        }
    }, [location.pathname]);

    useEffect(() => {
        let timeout;
        let warningTimeout;
        let interval;
        const events = ['mousemove', 'keydown', 'scroll', 'click'];
        const inactivityLimit = 30 * 60 * 1000;
        const warningDuration = 30 * 60 * 1000;
        let lastActivityTime = Date.now();

        const resetTimer = () => {
            const now = Date.now();
            if (now - lastActivityTime < 1000) return;
            lastActivityTime = now;

            clearTimeout(timeout);
            clearTimeout(warningTimeout);
            clearInterval(interval);
            setShowWarning(false);
            console.log('Inactivity timer reset due to user activity.');

            timeout = setTimeout(() => {
                setShowWarning(true);
                setTimeLeft(1800); // Start with 1800 seconds (30 minutes)
                console.log('Warning started, initial timeLeft:', 1800);
                const startWarning = Date.now();
                warningTimeout = setTimeout(() => {
                    console.log('User logged out due to inactivity.');
                    logout();
                }, warningDuration);

                interval = setInterval(() => {
                    const elapsed = Date.now() - startWarning;
                    const remainingSeconds = Math.max(0, 1800 - Math.floor(elapsed / 1000)); // Countdown from 1800
                    console.log('Interval tick, remainingSeconds:', remainingSeconds);
                    setTimeLeft(remainingSeconds);
                    if (remainingSeconds <= 0) {
                        clearInterval(interval);
                        console.log('Countdown finished');
                    }
                }, 1000);
            }, inactivityLimit);
        };

        console.log('Inactivity timer started.');
        resetTimer();
        events.forEach(event => window.addEventListener(event, resetTimer));

        return () => {
            clearTimeout(timeout);
            clearTimeout(warningTimeout);
            clearInterval(interval);
            console.log('Cleanup executed');
        };
    }, [logout]);

    const handleKeepLoggedIn = () => {
        setShowWarning(false);
        setTimeLeft(0);
    };

    if (!userData) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            {showWarning && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'white',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                    textAlign: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{ fontSize: '18px', marginBottom: '10px' }}>
                        Your session is about to expire
                    </div>
                    <div style={{ fontSize: '24px', color: 'red', marginBottom: '20px' }}>
                        {String(Math.floor(timeLeft / 3600)).padStart(2, '0')}:
                        {String(Math.floor((timeLeft % 3600) / 60)).padStart(2, '0')}:
                        {String(timeLeft % 60).padStart(2, '0')}
                    </div>
                    <button
                        onClick={handleKeepLoggedIn}
                        style={{
                            backgroundColor: 'red',
                            color: 'white',
                            padding: '10px 20px',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}
                    >
                        KEEP ME LOGGED IN
                    </button>
                </div>
            )}
            <MainDashBoard
                userDetails={userData}
                accessToken={accessToken}
            />
        </div>
    );
};

export default Dashboard;